<template>
  <h1 class="title-header">
    <span class="first-word">{{ first }}</span>
    <span class="rest-words">{{ rest }}</span>
  </h1>
</template>
<script>
export default {
  name: 'TitleHeader',
  props: {
    title: {
      type : String ,
      required : true
    }
  },
  computed:{
    first(){
      let i = this.title.indexOf(" ");
      if(i<=0){
        return this.title;
      }
      return this.title.substring(0,i);
    },
    rest(){
      let i = this.title.indexOf(" ");
      if(i<=0){
        return this.title;
      }
      return this.title.substring(i);
    }
  },
}
</script>

<style lang="scss" scoped>
.title-header {
  font-size: 2.2rem; /* Larger font size */
  font-weight: 800; /* Bolder font weight */
  margin: 0;
  padding: 15px 0; /* Adjusted padding */
  position: relative;
  display: flex;
  align-items: center;
  color: var(--text-primary);
  text-transform: uppercase;
  letter-spacing: 1px; /* Increased letter spacing */
  animation: fadeIn 0.6s ease; /* Slightly slower animation */

  .first-word {
    color: var(--accent-electric-blue); /* Keep accent color */
    margin-right: 10px; /* Increased margin */
  }

  .rest-words {
    color: var(--text-primary);
  }

  // Underline effect
  &::after {
    content: '';
    position: absolute;
    bottom: -5px; /* Slightly lower position */
    left: 0;
    width: 70px; /* Wider underline */
    height: 4px; /* Thicker underline */
    background: linear-gradient(to right, var(--accent-electric-blue), var(--accent-neon-purple)); /* Gradient for underline */
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* Stronger shadow */
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(15px); /* More pronounced animation */
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
